import { render, staticRenderFns } from "./CorrespondentsControl.vue?vue&type=template&id=0cf110dc&scoped=true"
import script from "./CorrespondentsControl.vue?vue&type=script&lang=js"
export * from "./CorrespondentsControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf110dc",
  null
  
)

export default component.exports